module.exports = __webpack_public_path__ + "static/audio/momenta_en.5a93655.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/narration/audio/en/momenta_en.mp3
// module id = nhTC
// module chunks = 0